import { AuthDetails } from '@lockton-apps/shared/interfaces';
import { createAction, props } from '@ngrx/store';

export enum LoginActionTypes {
  Login = '[Login Page] Login',
}

export const LoginActions = {
  login: createAction(
    LoginActionTypes.Login,
    props<{ authDetails: AuthDetails }>()
  ),
};
